import { IDtvButtonProps } from "@directv-digital/dds.ui.dtv-button";
import { IDtvTextProps } from "@directv-digital/dds.ui.dtv-text";

export enum MediaModuleImageVariant {
  ONE_UP,
  TWO_UP,
}

interface IImagesProps {
  xl?: { url: string; height?: string; width?: string; alt?: string };
  lg?: { url: string; height?: string; width?: string; alt?: string };
  md?: { url: string; height?: string; width?: string; alt?: string };
  sm?: { url: string; height?: string; width?: string; alt?: string };
  xs?: { url: string; height?: string; width?: string; alt?: string };
  alt?: string;
  id?: any;
}

interface CustomIDtvButtonProps extends IDtvButtonProps {
  backgroundColor?: string;
}

// Generated by Copilot- Start - 2026-02-25 22:29:48
export type CtaMobileLayout = "stacked" | "row";
export type ImageAlignment = "top" | "bottom";
// Generated by Copilot- End - 2026-02-25 22:29:48

export interface ICardProps {
  id?: string;
  eyebrow?: IDtvTextProps;
  headline?: IDtvTextProps;
  description?: IDtvTextProps;
  cta?: CustomIDtvButtonProps;
  secondaryCta?: CustomIDtvButtonProps;
  tertiaryCta?: CustomIDtvButtonProps;
  legalText?: IDtvTextProps;
  image?: IImagesProps;
  backgroundImage?: IImagesProps;
  textColor: string;
  backgroundColor?: string;
  emailCapture?: IEmailCaptureFormProps;
  ctaMobileLayout?: CtaMobileLayout;
  imageAlignment?: ImageAlignment;
}

export interface IMediaModuleImageCardProps extends ICardProps {
  id?: string;
  aboveTheFold?: boolean;
  variant?: MediaModuleImageVariant;
  cardHeight?: CardHeight;
  ctaMobileLayout?: CtaMobileLayout;
  imageAlignment?: ImageAlignment;
}

export enum CardHeight {
  AUTO = "auto",
  FIXED = "fixed",
  FLEX = "flex",
}

export interface IMediaModuleImageProps {
  id?: string;
  aboveTheFold?: boolean;
  cardHeight?: CardHeight;
  mediaCard?: ICardProps[];
  isInpageWidth?: boolean;
}

interface IEmailField {
  label?: string;
  emailErrorMessage?: string;
  size?: "small" | "medium" | "large";
}
export interface IEmailCaptureFormProps {
  id?: string;
  field?: IEmailField;
  submitCta?: CustomIDtvButtonProps;
  variant?: MediaModuleImageVariant;
}

export interface IMediaModuleStyleProps {
  backgroundColor?: string;
  textColor?: string;
  cardHeight?: CardHeight;
  ctaMobileLayout?: CtaMobileLayout;
  imageAlignment?: ImageAlignment;
  hasTertiaryCta?: boolean;
}
